/* --------------------------------------------------------------------------
	Video Local
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	function init() {
		if (!$('.js-video-wide-media').length) {
			return;
		}

		$('.js-video-local-pause').on('click', onPauseClick);
		$('.js-video-local-play').on('click', onPlayClick);
	}

	function onPauseClick() {
		$(this).removeClass('active').closest('.js-video-local-wrapper').find('.js-video-local-player').trigger('pause');
		$(this).closest('.js-video-local-wrapper').find('.js-video-local-play').addClass('active');
	}

	function onPlayClick() {
		$(this).removeClass('active').closest('.js-video-local-wrapper').find('.js-video-local-player').trigger('play');
		$(this).closest('.js-video-local-wrapper').find('.js-video-local-pause').addClass('active');
	}

	Site.OnInit.push(init);
})(jQuery, Site);
